// USERS
export const VIEW_ALL_USERS = "users.view";
export const MANAGE_ALL_USERS = "users.manage";
// ROLES
export const VIEW_ALL_ROLES = "roles.view";
export const MANAGE_ALL_ROLES = "roles.manage";
export const ASSIGN_ALL_ROLES = "roles.assign";
// PREFERENCES
export const VIEW_PREFERENCES = "preferences.view";
export const MANAGE_PREFERENCES = "preferences.manage";
// FEDERATIONS
export const VIEW_ALL_FEDERATIONS = "federations.view";
export const MANAGE_ALL_FEDERATIONS = "federations.manage";
export const VIEW_OWN_FEDERATION = "federation.own.view";
export const MANAGE_OWN_FEDERATION = "federation.own.manage";
// DISCIPLINES
export const VIEW_ALL_DISCIPLINES_OWN_FEDERATION = "disciplines.own.federation.view";
export const MANAGE_ALL_DISCIPLINES_OWN_FEDERATION = "disciplines.own.federation.manage";
export const VIEW_OWN_DISCIPLINE = "disciplines.own.view";
export const MANAGE_OWN_DISCIPLINE = "disciplines.own.manage";
// TEAMS
export const VIEW_ALL_TEAMS_OWN_DISCIPLINE = "teams.own.discipline.view";
export const MANAGE_ALL_TEAMS_OWN_DISCIPLINE = "teams.own.discipline.manage";
export const VIEW_OWN_TEAM = "teams.own.view";
export const MANAGE_OWN_TEAM = "teams.own.manage";
// ATHLETES
export const VIEW_ATHLETES_OWN_COACH = "athletes.own.coach.view";
export const MANAGE_ATHLETES_OWN_COACH = "athletes.own.coach.manage";
// EXERCISES
export const VIEW_ALL_EXERCISES = "exercises.all.view";
export const MANAGE_ALL_EXERCISES = "exercises.all.manage";
export const VIEW_OWN_EXERCISES = "exercises.own.view";
export const MANAGE_OWN_EXERCISES = "exercises.own.manage";
// CYCLES
export const VIEW_ALL_CYCLES = "cycles.all.view";
export const MANAGE_ALL_CYCLES = "cycles.all.manage";
export const VIEW_OWN_CYCLES = "cycles.own.view";
export const MANAGE_OWN_CYCLES = "cycles.own.manage";
// MEDIAS
export const VIEW_ALL_MEDIAS = "medias.all.view";
export const MANAGE_ALL_MEDIAS = "medias.all.manage";
export const VIEW_OWN_MEDIAS = "medias.own.view";
export const MANAGE_OWN_MEDIAS = "medias.own.manage";